import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DeleteItemsApi } from '../../../../../../../reduxToolkit/Commons/CommonsApi';
import CustomModal from '../../../../../../../components/Modal/CustomModal';
import CustomDescriptionModal from '../../../../../../../components/CustomDescriptionModal';
import {TABLES} from '../../../../../../../Apis/Tables';
import {errorMsg} from '../../../../../../../Apis/functions';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param selectedIds - The selected ids of the schedules to be deleted
 * @param show - Boolean to determine if the delete schedule modal should be shown
 * @param onHide - Function to hide the modal when triggered
 * @param setModified - Function to set the deleted status
 */

const DeleteScheduleModal = ({ selectedIds, show, onHide, setModified }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    /**
     * handle delete selected item
     */
    const handleDelete = () => {
        const body = selectedIds;
        dispatch(DeleteItemsApi({ tableName: TABLES.ATTENDANCE_DEPARTMENT, body })).then(({payload: {data: { success, code }}}) => {
            if (success) {
                setModified(true);
                onHide();
            } else errorMsg(code)
        });
    };

    return (
        <CustomModal
            show={show}
            onHide={onHide}
            onConfirm={handleDelete}
            title='delete'
            size='md'
            buttonConfirm='confirm'
            cancelButton={true}
        >
            <CustomDescriptionModal>
                {t('are_you_sure_you_want_to_delete')}
            </CustomDescriptionModal>
        </CustomModal>
    );
};

export default DeleteScheduleModal;
